import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  StatusToggleComponentButtonConfiguration,
  StatusToggleComponentConfiguration
} from "./status-toggle-component.configuration";

@Component({
  selector: 'app-status-toggle-component',
  templateUrl: './status-toggle-component.component.html',
  styleUrls: ['./status-toggle-component.component.scss']
})
export class StatusToggleComponentComponent<T> {

  @Input() configuration: StatusToggleComponentConfiguration<T> = StatusToggleComponentConfiguration.create<T>();
  
  /**
   * Evento emesso PRIMA di cambiare lo stato.
   * Permette al componente padre di eseguire validazioni e decidere se procedere.
   * Il componente padre deve gestire l'evento e chiamare confirm() o cancel() sulla callback.
   */
  @Output() beforeChange: EventEmitter<{value: T, confirm: () => void, cancel: () => void}> = new EventEmitter();

  getColor = (value: StatusToggleComponentButtonConfiguration<T>) => this.incrementalDisable(value) ? `#0000001F` : `var(--handlingState${value.value})`;

  setValue(value: T) {

    if (this.configuration.control?.disabled) return;

    if (this.configuration.control?.value === value) return;

    // Se c'è un listener, emetti l'evento e lascia che il padre decida
    if (this.beforeChange.observers.length > 0) {
      
      this.beforeChange.emit({
        value: value,
        confirm: () => {
          // Il padre ha confermato, procedi con il cambio
          this.configuration.control?.setValue(value);
        },
        cancel: () => {
          // Il padre ha annullato, non fare nulla
          // Il control mantiene il valore precedente
        }
      });
      
    } else {
      // Nessun listener, comportamento normale
      this.configuration.control?.setValue(value);
    }

  }

  incrementalDisable(button: StatusToggleComponentButtonConfiguration<T>) {

    if (this.configuration?.disabled) return true;

    if (this.configuration?.incremental) {

      const currentButtonIndex = this.configuration.values.findIndex((btn) => btn.value === this.configuration.control?.value);

      // Verifica se l'elemento successivo esiste nell'array
      const nextButton = this.configuration.values[currentButtonIndex + 1];

      // Disabilita il pulsante se non corrisponde al pulsante corrente o se l'elemento successivo non esiste
      return button.value !== this.configuration.control?.value && (!nextButton || nextButton.value !== button.value);

    }

    return false; // Se non è incrementale, non disabilitare il pulsante

  }

}
